import { render } from "./TaxNewinvoiceAr.vue?vue&type=template&id=2070cd6c&scoped=true"
import script from "./TaxNewinvoiceAr.vue?vue&type=script&lang=js"
export * from "./TaxNewinvoiceAr.vue?vue&type=script&lang=js"

import "./TaxNewinvoiceAr.vue?vue&type=style&index=0&id=2070cd6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2070cd6c"]])

export default __exports__